module.exports = __webpack_public_path__ + "static/media/SM-MT-11.b5acc0bd.mp3";